import { useRef } from 'react';
import { Camera, Image, Trash2 } from 'lucide-react';
import { Button } from '@/design-system';

export function BrandingAssetField({ title, description, url, dark, favicon, disabled, onUpload, onRemove }: {
  title: string; description: string; url: string | null; dark?: boolean; favicon?: boolean;
  disabled: boolean; onUpload: (file: File) => void; onRemove: () => void;
}) {
  const input = useRef<HTMLInputElement>(null);
  return <div className="flex flex-wrap items-start gap-4 py-4 first:pt-0 last:pb-0">
    <div className={`flex h-16 w-32 shrink-0 items-center justify-center rounded-lg border border-gray-200 p-2 ${dark ? 'bg-slate-800' : 'bg-gray-50'}`}>
      {url ? <img src={url} alt={title} className="max-h-full max-w-full object-contain" /> : <Image aria-hidden className="h-6 w-6 text-gray-400" />}
    </div>
    <div className="min-w-0 flex-1"><h4 className="text-sm font-medium text-gray-900">{title}</h4>
      <p className="mt-1 text-sm text-gray-500">{description}</p>
      <div className="mt-2 flex gap-2">
        <Button variant="ghost" size="sm" disabled={disabled} onClick={() => input.current?.click()}><Camera size={14} />{url ? 'Trocar' : 'Enviar imagem'}</Button>
        {url && <Button variant="ghost" size="sm" disabled={disabled} onClick={onRemove} aria-label={`Remover ${title}`}><Trash2 size={14} />Remover</Button>}
      </div>
      <input ref={input} type="file" aria-label={`Enviar ${title}`} className="sr-only" disabled={disabled}
        accept={favicon ? 'image/png,image/jpeg,image/webp,.ico' : 'image/png,image/jpeg,image/webp'}
        onChange={(event) => { const file = event.target.files?.[0]; if (file) onUpload(file); event.target.value = ''; }} />
    </div>
  </div>;
}
